import React from 'react';
import { FiPhone, FiMapPin, FiFacebook } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Contact = () => {
  const facebookUrl = "https://www.facebook.com/share/1CcMBE2nDA/";

  return (
    <section id="contact" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto text-center">
          <h2 className="text-brandOrange font-bold tracking-wider uppercase text-sm mb-2">Get in Touch</h2>
          <h3 className="text-4xl md:text-5xl font-extrabold text-royal mb-6">Ready to Book Your Lesson?</h3>
          <p className="text-gray-600 mb-12 text-lg max-w-2xl mx-auto">
            We're ready when you are! Reach out today to discuss your automatic driving lessons and get on the road to success.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left">
            {/* Phone Card */}
            <a 
              href="tel:07824448455" 
              className="flex items-center p-6 bg-gray-50 rounded-2xl border border-gray-100 group hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center text-brandOrange group-hover:bg-brandOrange group-hover:text-white transition-colors flex-shrink-0">
                <SafeIcon icon={FiPhone} className="w-7 h-7" />
              </div>
              <div className="ml-4">
                <p className="text-[10px] text-gray-500 font-bold uppercase tracking-widest mb-1">Call or Text</p>
                <p className="text-xl font-black text-royal">07824 448455</p>
              </div>
            </a>

            {/* Facebook Card */}
            <a 
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center p-6 bg-gray-50 rounded-2xl border border-gray-100 group hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center text-[#1877F2] group-hover:bg-[#1877F2] group-hover:text-white transition-colors flex-shrink-0">
                <SafeIcon icon={FiFacebook} className="w-7 h-7" />
              </div>
              <div className="ml-4">
                <p className="text-[10px] text-gray-500 font-bold uppercase tracking-widest mb-1">Social Media</p>
                <p className="text-xl font-black text-royal">Join Us On Facebook</p>
              </div>
            </a>

            {/* Location Card */}
            <div className="flex items-center p-6 bg-gray-50 rounded-2xl border border-gray-100">
              <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center text-brandOrange flex-shrink-0">
                <SafeIcon icon={FiMapPin} className="w-7 h-7" />
              </div>
              <div className="ml-4">
                <p className="text-[10px] text-gray-500 font-bold uppercase tracking-widest mb-1">Main Area</p>
                <p className="text-lg font-bold text-royal leading-tight">Weston & Surrounds</p>
              </div>
            </div>
          </div>

          <div className="mt-12 p-6 bg-brandOrange/5 rounded-2xl border border-brandOrange/10 inline-block">
            <p className="text-royal font-semibold">
              <span className="text-brandOrange mr-2">💡</span>
              Quick Tip: Texting or Messaging on Facebook is often the fastest way to reach us!
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;